import { HOTEL_DEPARTMENTS, normalizeDepartment } from "@/utils/alerts/departmentAlerts.js";

export const getNotificationPreference = (key, fallback) => {
  const value = localStorage.getItem(key);
  if (value === null || value === undefined) return fallback;
  if (value === "true") return true;
  if (value === "false") return false;
  return value;
};

export const setNotificationPreference = (key, value) => {
  localStorage.setItem(key, String(value));
};

export const getDeviceName = () => {
  const saved = localStorage.getItem("hotelNotificationDeviceName");
  if (saved) return saved;

  const platform = navigator.userAgentData?.platform || navigator.platform || "Device";
  const browser = navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome")
    ? "Safari"
    : navigator.userAgent.includes("Firefox")
      ? "Firefox"
      : navigator.userAgent.includes("Edg")
        ? "Edge"
        : navigator.userAgent.includes("Chrome")
          ? "Chrome"
          : "Browser";

  return `${browser} on ${platform}`;
};

export const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = `${base64String}${padding}`.replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
};

export const getVapidPublicKey = () => {
  return import.meta.env.VITE_VAPID_PUBLIC_KEY || "";
};

export const subscriptionToPayload = (subscription, metadata = {}) => {
  const json = subscription.toJSON();
  return {
    endpoint: json.endpoint,
    keys: json.keys,
    expirationTime: json.expirationTime,
    deviceName: metadata.deviceName || getDeviceName(),
    department: normalizeDepartment(metadata.department, HOTEL_DEPARTMENTS.reception),
    alertPreferences: metadata.alertPreferences || {},
  };
};
